/**
 * Created by falknisius on 03.06.16.
 */

export default class I18N {

  static messages = {}

  static set = (translations) => {
    I18N.messages = translations
  }

  static get = (selector, args = []) => {
    if (I18N.messages && I18N.messages[selector]) {
      let stringToReturn = I18N.messages[selector]

      const argsArray = Array.isArray(args) ? args : [args]

      argsArray.forEach((arg, index) => {
        if (arg !== null) {
          stringToReturn = stringToReturn.replace(`$${index}`, arg)
        }
      })

      return stringToReturn
    }
    return `$${selector}(${JSON.stringify(args)})`
  }

}



// WEBPACK FOOTER //
// ./src/utils/I18nMessageProvider.js